import { Box, Typography } from "@mui/material";
import { Icon } from "@iconify/react";

const GeneralProductInfo = () => {
  return (
    <Box
      sx={{ display: { lg: "flex" } }}
      alignItems={"center"}
      justifyContent={"space-around"}>
      <Box textAlign={"center"} sx={{ mb: { xs: 10 } }}>
        <Icon icon="tabler:award" fontSize={30} color="gray" />
        <Typography variant="h5" color={"secondary.dark"} mt={5}>
          ضمانت اصالت کالا
        </Typography>
      </Box>
      <Box textAlign={"center"} sx={{ mb: { xs: 10 } }}>
        <Icon icon="tabler:clock" fontSize={30} color="gray" />
        <Typography variant="h5" color={"secondary.dark"} mt={5}>
          سرعت در تحویل مرسوله
        </Typography>
      </Box>
      <Box textAlign={"center"} sx={{ mb: { xs: 10 } }}>
        <Icon icon="tabler:cart-down" fontSize={30} color="gray" />
        <Typography variant="h5" color={"secondary.dark"} mt={5}>
          تضیمن بهترین قیمت در ایران
        </Typography>
      </Box>
      {/* <Box textAlign={'center'} sx={{ mb: { xs: 10 } }}>
        <Icon icon='tabler:map' fontSize={30} color='gray' />
        <Typography variant='h5' color={'secondary.dark'} mt={5}>
          ارسال رایگان به سراسر کشور
        </Typography>
      </Box> */}
    </Box>
  );
};

export default GeneralProductInfo;
